
        import * as module0 from './controllers/factur_x_validator_controller.js';import * as module1 from './controllers/harness_control_controller.js';import * as module2 from './controllers/hermes_note_controller.js';import * as module3 from './controllers/navigation_controller.js';import * as module4 from './controllers/webmcp_controller.js'
        const modules = {
            "./controllers/factur_x_validator_controller.js": module0,
            "./controllers/harness_control_controller.js": module1,
            "./controllers/hermes_note_controller.js": module2,
            "./controllers/navigation_controller.js": module3,
            "./controllers/webmcp_controller.js": module4,
        };
        export default modules;
      